import React, { useEffect, useState } from "react";
import GenericStickyModal from "web/react/components/generic-sticky-modal/generic-sticky-modal";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import analytics from "web/script/analytics/analytics";
import requester from "web/script/modules/requester";
import history from "web/script/utils/history";
import styles from "./product-preview-size-guide.css";

export const PRODUCT_PREVIEW_SIZE_GUIDE_OVERLAY_NAME = "product-preview-size-guide";

function ProductPreviewSizeGuide(): JSX.Element | null {
    const [content, setContent] = useState<string>("");

    const overlay = useOverlayWatcher(PRODUCT_PREVIEW_SIZE_GUIDE_OVERLAY_NAME);
    const isOpen = !!overlay;

    async function trigger(sizeGuideLink): Promise<void> {
        const options = {
            headers: {
                Accept: "text/html",
            },
        };

        const response = await requester(sizeGuideLink, options).then(requester.toText);
        setContent(response);
    }

    function onClose(): void {
        analytics.event("pdp_preview", "size_guide_close");
        history.popOverlay(PRODUCT_PREVIEW_SIZE_GUIDE_OVERLAY_NAME);
    }

    useEffect(() => {
        if (isOpen) {
            analytics.event("pdp_preview", "size_guide_open");

            trigger(overlay && overlay.sizeGuideLink);
        }
    }, [isOpen]);

    if (!content) return null;

    return (
        <GenericStickyModal className={styles.modal} isOpen={isOpen} onClose={onClose}>
            <div
                className={styles.modalContent}
                dangerouslySetInnerHTML={{ __html: content }}
                data-allowTouch={true}
            />
        </GenericStickyModal>
    );
}

export default ProductPreviewSizeGuide;
